import { css, DefaultTheme } from 'styled-components'

export type MarginSpacing = {
  top?: number
  bottom?: number
  left?: number
  right?: number
}

const marginHandler = ({ $margin }: { theme: DefaultTheme; $margin?: MarginSpacing }) =>
  $margin &&
  css`
    margin-top: ${({ theme }) => $margin.top && `${theme.spacing($margin.top)}`};
    margin-left: ${({ theme }) => $margin.left && `${theme.spacing($margin.left)}`};
    margin-right: ${({ theme }) => $margin.right && `${theme.spacing($margin.right)}`};
    margin-bottom: ${({ theme }) => $margin.bottom && `${theme.spacing($margin.bottom)}`};
  `

const paddingHandler = ({ $padding }: { $padding?: MarginSpacing }) =>
  $padding &&
  css`
    padding-top: ${({ theme }) => $padding.top && `${theme.spacing($padding.top)}`};
    padding-left: ${({ theme }) => $padding.left && `${theme.spacing($padding.left)}`};
    padding-right: ${({ theme }) => $padding.right && `${theme.spacing($padding.right)}`};
    padding-bottom: ${({ theme }) => $padding.bottom && `${theme.spacing($padding.bottom)}`};
  `

export { marginHandler, paddingHandler }
